import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import Header2 from "./Header2";
import { updateUser, auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const Edit = () => {
  const [displayName, setDisplayName] = useState("");
  const [phone, setPhone] = useState("");
  const [profession, setProfession] = useState("");
  const [point, setPoint] = useState("");
  const [bio, setBio] = useState("");
  const [website, setWebsite] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [experience, setExperience] = useState("");
  const [user, setUser] = useState(null);
  const [saving, setSaving] = useState(false);
  const [snack, setSnack] = useState({ open: false, severity: "success", msg: "" });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        try {
          const snap = await getDoc(doc(db, "users", firebaseUser.uid));
          if (snap.exists()) {
            const data = snap.data();
            setDisplayName(data.displayName || "");
            setPhone(data.phone || "");
            setProfession(data.profession || "");
            setPoint(data.point || "");
            setBio(data.bio || "");
            setWebsite(data.website || "");
            setLinkedin(data.linkedin || "");
            setExperience(data.experience || "");
          }
        } catch (e) {
          console.error("Error cargando datos:", e);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = async () => {
    setSaving(true);
    try {
      await updateUser(user.uid, displayName, profession, phone, point, bio, website, linkedin, experience);
      setSnack({ open: true, severity: "success", msg: "¡Cambios guardados con éxito!" });
    } catch (e) {
      setSnack({ open: true, severity: "error", msg: "Error al guardar. Intentá de nuevo." });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container>
      <Header2/>
      <Container sx={{ mt: "84px", pb: 12, px: 2 }}>
        <Container
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            width: "100%",
            textAlign: "left",
            marginTop: "20px",
          }}
        >
          <TextField
            label="Nombre"
            variant="outlined"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Profesión"
            variant="outlined"
            value={profession}
            onChange={(e) => setProfession(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Años / tiempo de experiencia"
            variant="outlined"
            value={experience}
            onChange={(e) => setExperience(e.target.value)}
            fullWidth
            margin="normal"
            placeholder="Ej: 5 años"
          />
          <TextField
            label="Curriculum / Bio"
            variant="outlined"
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            fullWidth
            margin="normal"
            multiline
            rows={4}
            placeholder="Describí tu experiencia, habilidades y servicios..."
          />
          <TextField
            label="Teléfono"
            variant="outlined"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Localidad"
            variant="outlined"
            value={point}
            onChange={(e) => setPoint(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Sitio web"
            variant="outlined"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
            fullWidth
            margin="normal"
            placeholder="https://"
          />
          <TextField
            label="LinkedIn"
            variant="outlined"
            value={linkedin}
            onChange={(e) => setLinkedin(e.target.value)}
            fullWidth
            margin="normal"
            placeholder="linkedin.com/in/tu-perfil"
          />
          <Button
            sx={{ marginTop: 2 }}
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={saving}
            startIcon={saving ? <CircularProgress size={18} color="inherit" /> : null}
          >
            {saving ? "Guardando..." : "Guardar cambios"}
          </Button>
        </Container>
      </Container>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          severity={snack.severity}
          variant="filled"
          sx={{ borderRadius: "14px" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Edit;
